export const CHAT_MAX_WIDTH = 768
export const CHAT_SCROLL_DELAY = 300
export const CHAT_DIVIDER_DELAY = 100
export const CHAT_TOOL_CODE_AREA_MAX_HEIGHT = 126
